export default {
  groups: {
    dashboards: 'Tablouri de bord',
    online_shop: 'Magazin online',
    home: 'Acasă',
    marketing: 'Marketing',
    reservations: 'Rezervări',
    website: 'Website',
    orders_portal: 'Lansați portalul de comenzi',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Aplicație Mobilă',
    phone_answering: 'Răspuns Telefonic',
    pricing: 'Prețuri',
    team: 'Echipă',
    data_deletion_requests: 'Cereri de ștergere a datelor',
    partner: 'Partener',
  },
  get_started: {
    title: 'Începeți',
  },
  onboarding: {
    title: 'Lansare',
  },
  new_restaurant: {
    title: 'Restaurant nou',
  },
  gift_cards: {
    title: 'Carduri Cadou',
  },
  top_items: {
    title: 'Produse de Top',
  },
  dashboards: {
    title: 'Tablouri de bord',
    children: {
      general: 'General',
      restaurant_details: 'Detalii Restaurant',
      external_delivery: 'Livrare Externă',
      overview: 'Prezentare generală',
      orders: 'Comenzi după sursă',
      google: 'Google',
      customers: 'Clienți',
    },
  },
  customer_base: {
    title: 'Bază de Clienți',
  },
  new_company: {
    title: 'Restaurant nou',
  },
  agent_ops_queue: {
    title: 'Sugestii AI',
  },
  external_delivery_support: {
    title: 'Suport livrare externă',
  },
  payment_gateways: {
    title: 'Gateway-uri de Plată',
  },
  developers: {
    title: 'Dezvoltatori',
  },
  feature_flags: {
    title: 'Indicatoare de Funcții',
  },
  test_restaurants: {
    title: 'Restaurante de test',
  },
  partners: {
    title: 'Parteneri',
  },
  partner: {
    children: {
      account: 'Cont',
      branding: 'Branding',
      payment_gateway: 'Poartă de plată',
      billing: 'Facturare',
      tax_currency: 'Taxe și valută',
      service_fee_calculator: 'Calculator taxă de serviciu',
      processing_fees: 'Comisioane de procesare',
    },
  },
  going_live: {
    title: 'Lansare',
    children: {
      setup_package_fulfillments: 'Îndepliniri Logsta',
      polygraphy: 'Produse Tipărite',
    },
  },
  franchises: {
    title: 'Branduri',
  },
  setup_package_fulfillments: {
    title: 'Îndepliniri pachet de configurare',
  },
  website: {
    title: 'Website',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Rezervare',
    children: {
      overview: 'Prezentare generală',
      booking_availability: 'Disponibilitate Rezervări',
      settings: 'Setări',
      general: 'General',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Abonamente',
    children: {
      subscriptions: 'Abonamente',
      products: 'Produse',
    },
  },
  sales: {
    title: 'Vânzări',
    children: {
      orders: 'Comenzi',
      receipts: 'Chitanțe clienți',
      external_deliveries: 'Livrări externe',
    },
  },
  billing: {
    title: 'Rapoarte',
    children: {
      monthly_statements: 'Declarații Lunare',
      payouts: 'Plăți',
      invoices: 'Facturi',
      subscription: 'Abonament',
      sales_summary: 'Rezumat vânzări',
      internal_invoice_items: 'Elemente factură internă',
      income_reports: 'Rapoarte de venituri',
      tax_reports: 'Rapoarte fiscale',
    },
  },
  master_menu: {
    title: 'Sincronizare brand',
  },
  menu: {
    title: 'Meniu',
    children: {
      master_overview: 'Branduri',
      manage_menus: 'Gestionare meniuri',
      modifiers: 'Modificatori',
      smart_pricing: 'Prețuri inteligente',
      upsell_items: 'Produse upsell',
      sold_out_items: 'Produse epuizate',
      import: 'Import',
      edit_history: 'Istoric modificări',
    },
  },
  my_store: {
    title: 'Informațiile mele',
    children: {
      settings: 'Profil',
      gallery: 'Galerie',
      business_information: 'Informații despre afacere',
      documents: 'Documentele mele',
      personal_information: 'Informații personale',
      bank_info: 'Date bancare',
      tax_info: 'Date fiscale',
      shipping_info: 'Date de livrare',
      google_profile: 'Profil Google',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Informații legale',
      post_launch: 'Post-Lansare',
      tax_currency: 'Taxe și valută',
    },
  },
  opening_hours: {
    title: 'Program & Locație',
    children: {
      opening_hours: 'Program de lucru',
      location: 'Locație',
    },
  },
  order_settings: {
    title: 'Setări comenzi',
    children: {
      takeout: 'Metode de comandă',
      order_layout: 'Aspect comandă',
      payment_methods: 'Metode de plată',
      connect_paypal: 'Conectare PayPal',
      tips: 'Bacșișuri',
      service_fee: 'Taxe',
      processing_fees: 'Comisioane de procesare',
      receipt: 'Chitanță',
      staff_credentials: 'Credențiale personal',
      integrations: 'Integrări',
      terminal: 'Terminal',
      invoices: 'Facturi',
    },
  },
  mobile_app: {
    title: 'Aplicație Mobilă',
    children: {
      overview: 'Prezentare generală',
      updates: 'Actualizări',
      intro_screen: 'Ecran Intro',
    },
  },
  marketing: {
    children: {
      overview: 'Prezentare generală',
      followers: 'Urmăritori',
      email_messages: 'Mesaje email',
      push_notifications: 'Notificări push',
      promo_codes: 'Coduri promoționale',
      offers: 'Oferte',
      google_business: 'Google Business',
      google_review_program: 'Program recenzii Google',
      loyalty_program: 'Program de fidelitate',
      polygraphy: 'Produse Tipărite',
      tracking_links: 'Linkuri de urmărire',
      google_ads: 'Google Ads',
      website_analytics: 'Analiză website',
      featured_posts: 'Postări Aplicație Mobilă',
    },
  },
  loyalty_tablet: {
    title: 'Tabletă Fidelitate',
    children: {
      dashboard: 'Panou de control',
      settings: 'Setări',
      credentials: 'Credențiale',
    },
  },
  contract: {
    title: 'Contract',
    children: {
      agreement: 'Acord',
      template: 'Șablon',
    },
  },
  team: {
    children: {
      managers: 'Manageri',
      reports: 'Rapoarte',
    },
  },
};
